@if (pagination.totalPages > 1) {
  <div class="category-pagination fx-row fx-row-h-center fx-row-v-center">
    @for (control of pagination.controls; track $index) {
      <div class="category-pagination-item fx-col fx-col-v-center">
        @if (control.isArrow) {
          <a
            class="category-pagination-arrow fx-row fx-row-v-center fx-row-h-center"
            role="button"
            [attr.tabindex]="control.isActive ? 0 : -1"
            [attr.aria-disabled]="!control.isActive"
            [attr.aria-label]="control.direction == 'right' ? 'Next page' : 'Previous page'"
            (keydown.enter)="control.isActive && paginate(control.direction == 'right' ? pagination.next.queryParams : pagination.previous.queryParams)"
            (keydown.space)="$event.preventDefault(); control.isActive && paginate(control.direction == 'right' ? pagination.next.queryParams : pagination.previous.queryParams)"
            [class.disabled]="!control.isActive"
      (click)="
        control.isActive &&
          (control.direction == 'right'
            ? paginate(pagination.next.queryParams)
            : paginate(pagination.previous.queryParams))
      "
            >
            <mat-icon>{{ "chevron_" + control.direction }}</mat-icon>
          </a>
        }
        @if (control.isEllipsis) {
          <span class="category-pagination-ellipsis fx-row fx-row-h-center fx-row-v-center">
            &hellip;
          </span>
        }
        @if (control.isNumber) {
          <a
            class="category-pagination-number fx-row fx-row-h-center fx-row-v-center"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Page ' + control.number"
            [attr.aria-current]="control.isActive ? 'page' : null"
            [class.active]="control.isActive"
            (click)="paginate(control.queryParams)"
            (keydown.enter)="paginate(control.queryParams)"
            (keydown.space)="paginate(control.queryParams); $event.preventDefault()"
            >
            <span>{{ control.number }}</span>
          </a>
        }
      </div>
    }
  </div>
}
